<template>
  <page-header-wrapper @back="back">
    <template v-slot:title>
      {{ formTitle }}
    </template>
    <LoadingMask :visible="showLoadingMask" :text="loadingText" />

    <a-card :bordered="false">
      <a-form-model ref="form" :model="form" :rules="rules" :label-col="{ span: 2 }" :wrapper-col="{ span: 20 }">
        <!-- <a-form-model-item label="消息类型" prop="noticeType" >
              <a-select placeholder="请选择" v-model="form.noticeType" style="width: 200px;">
                <a-select-option v-for="(d, index) in dict.type['sys_notice_type']" :key="index" :value="parseInt(d.value)">{{
                    d.label }}</a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item label="状态" prop="status" >
              <a-radio-group v-model="form.bstatus" button-style="solid" @change="changeStatus">
                <a-radio-button v-for="(d, index) in dict.type['sys_notice_status']" :key="index" :value="parseInt(d.value)">{{
                    d.label }}</a-radio-button>
              </a-radio-group>
            </a-form-model-item> -->
        <a-form-model-item label="标题" prop="newsTitle">
          <a-input size="large" width="200px" v-model="form.newsTitle" placeholder="请输入标题" />
        </a-form-model-item>
        <a-form-model-item label="接收人" prop="newsClients">
          <a-radio-group v-model="form.newsClients">
            <a-radio-button :value="0"> 全部用户 </a-radio-button>
            <a-radio-button :value="1">部分用户 </a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="用户" prop="newsClient" v-if="form.newsClients==1">
          <!-- <a-select
            show-search
            :allowClear="true"
            v-model="form.userIds"
            placeholder="请选择"
            option-filter-prop="children"
            :filter-option="filterOption"
            mode="multiple"
            @focus="handlefocus"
          >
            <a-select-option v-for="d in brandList" :key="d.id">{{ d.name }}</a-select-option>
          </a-select> -->
          <a-button type="primary" @click="handlefocus"> 去选择 </a-button>
        </a-form-model-item>
        <!-- <a-form-model-item label="消息终端" prop="newsClient">
          <a-radio-group v-model="form.newsClient">
            <a-radio-button :value="0"> 全部 </a-radio-button>
            <a-radio-button :value="1"> 小程序(APP) </a-radio-button>
            <a-radio-button :value="3"> PC </a-radio-button>
          </a-radio-group>
        </a-form-model-item> -->
        <!-- <a-form-model-item label="消息类型" prop="newsType">
          <a-radio-group v-model="form.newsType">
            <a-radio-button :value="0"> 系统消息 </a-radio-button>
            <a-radio-button :value="1"> 用户消息 </a-radio-button>
          </a-radio-group>
        </a-form-model-item> -->
        <!-- <a-form-model-item label="接受用户类型" prop="newsClient">
          <a-radio-group v-model="form.newsClient">
            <a-radio-button :value="0"> 普通用户 </a-radio-button>
            <a-radio-button :value="1">系统用户 </a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="接受人" prop="newsClient">
          <a-radio-group v-model="form.newsClient">
            <a-radio-button :value="0"> 普通用户 </a-radio-button>
            <a-radio-button :value="1">系统用户 </a-radio-button>
          </a-radio-group>
        </a-form-model-item> -->
        <a-form-model-item label="简述" prop="newsSketch">
          <a-textarea placeholder="请输入简述" auto-size v-model="form.newsSketch" />
        </a-form-model-item>
        <a-form-model-item label="内容" prop="newsContent">
          <editor v-model="form.newsContent" />
        </a-form-model-item>
      </a-form-model>
      <a-space style="margin-left: 8.5%">
        <a-button type="primary" :loading="submitLoading" :disabled="submitLoading" @click="submitForm">
          发布
        </a-button>
        <a-button type="dashed" @click="back"> 取消 </a-button>
      </a-space>
    </a-card>
    <chooseUser ref="chooseUser" @backCange="backCange"></chooseUser>
  </page-header-wrapper>
</template>

<script>
import { getNotice, addNotice, updateNotice } from '@/api/system/notice'
import Editor from '@/components/Editor'
import LoadingMask from '@/components/LoadingMask'
import bus from '@/utils/bus'
import events from '@/components/MultiTab/events'
import chooseUser from './chooseUser.vue'
export default {
  name: 'NoticeForm',
  components: {
    Editor,
    LoadingMask,
    chooseUser,
  },
  dicts: ['sys_notice_status', 'sys_notice_type'],
  data() {
    return {
      wrapperCol: { span: 48 },
      submitLoading: false,
      showLoadingMask: false,
      loadingText: '',
      total: 0,
      id: undefined,
      formTitle: '',
      // 表单参数
      form: {
        id: undefined,
        newsTitle: undefined,
        newsClient: 0,
        newsContent: undefined,
        newsSketch: undefined,
        userList: '',
        newsType: 0,
        newsClients: 0,
        userIds: [],
        userType: 1,
      },
      rules: {
        noticeType: [{ required: true, message: '请输入消息简述	', trigger: 'blur' }],
        newsContent: [{ required: true, message: '请输入消息内容	', trigger: 'blur' }],
        newsTitle: [{ required: true, message: '请输入消息标题', trigger: 'blur' }],
      },
      open: false,
    }
  },
  filters: {},
  created() {},
  computed: {},
  watch: {
    formTitle: {
      handler(newTitle) {
        if (newTitle) {
          // 动态设置页面标题
          document.title = newTitle + ' - ' + (document.title.split(' - ').pop() || '管理系统')
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.id = this.$route.params.id
    this.formTitle = this.$route.params.formTitle
    // 动态设置页面标题
    document.title = this.formTitle + ' - ' + (document.title.split(' - ').pop() || '管理系统')
    if (this.id) {
      this.handleUpdate(this.id)
    } else {
      this.handleAdd()
    }
  },
  methods: {
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    backCange(e) {
      console.log(e, '顶顶顶顶')
      this.form.userIds = e
    },
    changeStatus(e) {
      const status = e.target.value
      this.form.status = status === '0' ? '1' : '0'
    },
    // 表单重置
    reset() {
      this.form = {
        id: undefined,
        newsTitle: undefined,
        newsClient: 0,
        newsContent: undefined,
        newsSketch: undefined,
        userList: '',
        newsClients: 0,
        newsType: 0,
        userType: 1,
        userIds: [],
      }
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset()
      this.formTitle = '添加消息'
    },
    // 点击获取焦点弹窗选择用户
    handlefocus() {
      this.$nextTick(() => {
        this.$refs.chooseUser.init()
      })
    },
    /** 修改按钮操作 */
    handleUpdate(id) {
      this.reset()
      const noticeId = id
      getNotice(noticeId).then((response) => {
        const str = response.data.status
        this.$set(response.data, 'bstatus', str)
        this.form = response.data
        this.formTitle = '修改消息'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
       this.$refs.form.validate((valid, object) => {
        if (valid) {
          // 显示加载遮罩
          this.showLoadingMask = true
          this.loadingText = this.form.id !== undefined ? '正在修改消息...' : '正在发布消息...'
          this.submitLoading = true

          const apiCall = this.form.id !== undefined ? updateNotice(this.form) : addNotice(this.form)

          apiCall
            .then((response) => {
              this.$message.success(this.form.id !== undefined ? '修改成功' : '新增成功', 3)
              // 去更新列表页的数据
              bus.$emit('updateNoticeList')
              this.back()
            })
            .catch((error) => {
              console.error('提交失败:', error)
              this.$message.error('操作失败，请重试')
            })
            .finally(() => {
              this.submitLoading = false
              this.showLoadingMask = false
              this.loadingText = ''
            })
        } else {
          // 表单验证失败，显示错误信息
          const messages = Object.values(object).flatMap((errorArray) => errorArray.map((item) => item.message))
          this.$message.error(messages.join('；'))
          return false
        }
      })
    },
    back() {
      const pages = this.$store.pages
      pages.indexOf(this.$route)
      events.$emit('close', pages.indexOf(this.$route))
      this.$router.push('/system/notice')
    },
    onClose() {
       const that = this
      this.$confirm({
        title: '是否确认关闭清空数据',
        onOk() {
          that.open = false
        },
        onCancel() {},
      })
    },
    handleSubmit() {
      this.$refs.baseForm.validate((valid) => {
        if (valid) {
          this.open = true
        } else {
          return false
        }
      })
    },
    // 关闭当前标签页
  },
}
</script>
